import { BaseModule } from "./base.module";

export class GenericStateMachineEventsModule extends BaseModule {
	cachedWindowSize = {
		innerWidth: window.innerWidth,
		innerHeight: window.innerHeight,
	};
	initialize() {
		document.addEventListener('scroll', () => {
			this.triggerEventOnElement('scrolling', document.documentElement);
		});

		window.addEventListener('resize', (event) => {
			let eventWindowSize = {
				innerWidth: window.innerWidth,
				innerHeight: window.innerHeight,
			}
			if (
				eventWindowSize.innerWidth < this.cachedWindowSize.innerWidth ||
				eventWindowSize.innerWidth > this.cachedWindowSize.innerWidth
			) {
				this.triggerEventOnElement('viewport-width-resizing', document.documentElement, eventWindowSize);
				this.cachedWindowSize = Object.assign({}, eventWindowSize);
			}
		});
	}
}